import Stack from "@mui/material/Stack"
import StatusFilter from "./shared/StatusFilter"
import Typography from "@mui/material/Typography"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import RestartAltIcon from "@mui/icons-material/RestartAlt"
import DownloadIcon from "@mui/icons-material/Download"
import {
  useGetDepartmentQuery,
  useGetLineQuery,
  useGetSelectQuery,
} from "../../api/InterviewsApi"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import queryString from "query-string"
import { useEffect } from "react"
import React from "react"
import { useForm } from "react-hook-form"
import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import Popover from "@mui/material/Popover"
import { Divider } from "@mui/material"

const StatisticFilters = ({ setOpen, open }: any) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const openPopover = Boolean(anchorEl)
  const id = openPopover ? "simple-popover" : undefined
  const [searchParams, setSearchParams] = useSearchParams()

  const [filledFieldsCount, setFilledFieldsCount] = React.useState<number>(-1)

  const {
    handleSubmit,
    register,
    formState,
    control,
    watch,
    resetField,
    setValue,
    clearErrors,
    reset,
  } = useForm<any>({
    defaultValues: {
      department: null,
      project: null,
      line: null,
    },
  })

  const navigate = useNavigate()
  const location = useLocation()

  const queryParams = queryString.parse(location.search)

  // Функция для обновления параметров в URL
  const updateFiltersInUrl = (newFilters: any) => {
    const updatedParams = {
      ...queryParams,
      ...newFilters,
    }
    Object.keys(updatedParams).forEach((key) => {
      if (updatedParams[key] === null || updatedParams[key] === undefined) {
        delete updatedParams[key]
      }
    })

    const updatedUrl = `${location.pathname}?${queryString.stringify(
      updatedParams,
    )}`
    navigate(updatedUrl) // Prevents adding to history stack
  }

  const { errors } = formState

  const getFilledFieldsCount = () => {
    // if (!watch("search")) return 0
    let count = 0
    for (const key in formState?.defaultValues) {
      const value = watch(key)
      console.log(key, value)

      if (value !== null && value !== undefined) {
        count += 1
      }
    }

    return count
  }

  const status = searchParams.get("status")

  useEffect(() => {
    updateFiltersInUrl({
      status: status,
      department: watch("department.id"),
      project: watch("project.id"),
      line: watch("line.id"),
    })

    setFilledFieldsCount(getFilledFieldsCount())
  }, [watch("department.id"), watch("project.id"), watch("line.id"), status])

  const selects = useGetSelectQuery()

  const department = useGetDepartmentQuery(`${watch("project.id")}`, {
    skip: !watch("project.id"),
  })

  const line = useGetLineQuery(watch("department.id"), {
    skip: !watch("department.id"),
  })

  return (
    <Stack
      direction={"row"}
      alignItems="center"
      justifyContent={"space-between"}
      spacing={"20px"}
      sx={{ width: "100%" }}
    >
      <Stack direction={"row"} alignItems="center" spacing="10px">
        {/* <Typography
          sx={{ fontSize: 16, fontWeight: "bold", alignSelf: "center" }}
        >
          Статистика по графикам
        </Typography>
        <Divider orientation="vertical" flexItem /> */}
        <Stack direction={"row"} alignItems="center" spacing="10px">
          {selects.data && (
            <Autocomplete
              sx={{ width: "200px" }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={watch("project")}
              loading={selects.isLoading}
              {...register("project")}
              size="small"
              getOptionKey={(option) => option.id}
              fullWidth
              onChange={(event: any, value: any) => {
                setValue("project", value)
                resetField("department")
                resetField("line")
              }}
              options={selects?.data.filterOptions?.project}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  {...params}
                  placeholder="Проект"
                />
              )}
            />
          )}

          <Autocomplete
            sx={{ width: "200px" }}
            disabled={watch("project.id") ? false : true}
            loading={department?.isLoading}
            value={watch("department")}
            {...register("department")}
            size="small"
            getOptionKey={(option) => option.id}
            fullWidth
            onChange={(event: any, value: any) => {
              setValue("department", value)
              resetField("line")
            }}
            options={department?.data || []}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                variant="outlined"
                {...params}
                placeholder="Направление"
              />
            )}
          />

          <Autocomplete
            sx={{ width: "200px" }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disabled={watch("department.id") ? false : true}
            value={watch("line")}
            {...register("line")}
            size="small"
            getOptionKey={(option) => option.id}
            fullWidth
            onChange={(event: any, value: any) => {
              setValue("line", value)
            }}
            options={line?.data?.data || []}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField variant="outlined" {...params} placeholder="Линия" />
            )}
          />
        </Stack>
        {filledFieldsCount > 0 && (
          <Button
            disabled={filledFieldsCount === 0}
            onClick={() => {
              reset()
              updateFiltersInUrl({})
            }}
            variant="text"
            startIcon={<RestartAltIcon />}
          >
            Сбросить фильтры
          </Button>
        )}
      </Stack>
      <Box>
        <Button
          onClick={() => setOpen({ ...open, weekStatisticDialog: true })}
          variant="outlined"
          endIcon={<DownloadIcon />}
          sx={{ mr: "10px" }}
        >
          Отчётность
        </Button>
        <StatusFilter />
      </Box>
    </Stack>
  )
}

export default StatisticFilters
